// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"A1-z"};